export const ACTIVATED_DEFAULTS = {
    activatedVerseIndex: -1,
}
